import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addMonths } from 'date-fns';
import { CaptionLabel } from 'components/CaptionLabel';
import { MonthsDropdown } from 'components/MonthsDropdown';
import { YearsDropdown } from 'components/YearsDropdown';
import { useDayPicker } from 'contexts/DayPicker';
import { useNavigation } from 'contexts/Navigation';
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
export function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(addMonths(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (_jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (_jsxs("div", __assign({ className: classNames.caption_dropdowns, style: styles.caption_dropdowns }, { children: [_jsx("div", __assign({ className: classNames.vhidden }, { children: captionLabel })), _jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), _jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] })));
}
//# sourceMappingURL=CaptionDropdowns.js.map